import "bootstrap/dist/css/bootstrap.css";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Uvod from "./components/Uvod";

function App() {
  return (
    <HashRouter>
      <Switch>
        <Route path="/:lazne" component={Uvod} />
        <Route path="/" component={Uvod} />
      </Switch>
    </HashRouter>
  );
}

export default App;
